module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.to === '') ? _c('button', {
    class: _vm.classes
  }, [_vm._t("default")], 2) : _c('router-link', {
    class: _vm.classes,
    attrs: {
      "to": _vm.to
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13216aee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/VButton.vue
// module id = 1637
// module chunks = 1